import script from "./GstFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./GstFooter.vue?vue&type=script&setup=true&lang=js"

import "./GstFooter.vue?vue&type=style&index=0&id=11f307de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11f307de"]])

export default __exports__